/* LH | Second item discount via hidden code (Leon, 24.10.2026, socks).
 *
 * Leon: no automatic discount. Two different sock products bought separately must not get the second pair
 * price, only a second pair made through the cross-sell on the product page. So the discount is a hidden BXGY
 * code (metaobject lh_cross_sell, field discount_code: buy 1 of the product group, get 1 at -discount_pct, once
 * per order) and this script is the only place that puts it into the cart:
 * - wanted while the cart holds a second item: a line with _parent_customization_id (TeeInBlue cross-sell) whose
 *   SKU matches the entry's main_skus and whose parent line (_customization_id) is the same product,
 * - or while a product page form holds a second item that is not in the cart yet (lh-cross-sell-pair.js calls
 *   window.lhCrossSellPending), so the drawer opens with the right price right after add to cart,
 * - otherwise removed. Codes the customer entered stay untouched.
 * Also: at most one second item per main item, always quantity 1.
 * Runs once on page load and after every cart change (fetch to /cart/add|change|update|clear). Our own requests
 * carry X-LH-Cart and never trigger us or lh-partner-upsell-cart.js.
 * Rules: window.lhCrossSellRules from snippets/lh-cross-sell-cart.liquid.
 */
(function () {
  if (window.__lhCsCartLoaded) return;
  window.__lhCsCartLoaded = true;

  var rules = (window.lhCrossSellRules || []).map(function (r) {
    return {
      code: String(r.code || '').trim(),
      family: String(r.family || r.code || '').trim(),
      skus: (r.skus || []).map(function (x) { return String(x).trim(); }).filter(Boolean)
    };
  }).filter(function (r) { return r.code && r.skus.length; });
  if (!rules.length) return;

  var pending = {};
  var busy = false, again = false;
  var H = { 'X-LH-Cart': '1' };

  function matches(rule, sku) {
    sku = sku || '';
    return rule.skus.some(function (p) { return sku.slice(0, p.length) === p; });
  }

  function isPair(rule, i, items) {
    var parent = i.properties && i.properties._parent_customization_id;
    if (!parent || !matches(rule, i.sku)) return false;
    return items.some(function (m) {
      return m !== i && m.product_id === i.product_id && m.properties && String(m.properties._customization_id) === String(parent);
    });
  }

  function pairsInCart(rule, items) {
    return items.filter(function (i) { return isPair(rule, i, items); }).length;
  }

  // One code per number of second items (Leon, 24.10.2026: every additional pair gets its discount, other socks none).
  // Shopify cannot target a line with a code, and two such codes never apply together, so there is one code per count:
  // <code> = once per order, <code>-2 = twice ... up to <code>-MAX, each a BXGY with that uses per order limit.
  var MAX = 4;
  function codeFor(rule, n) {
    if (n <= 0) return '';
    n = Math.min(n, MAX);
    return n === 1 ? rule.code : rule.code + '-' + n;
  }
  // Every code of the family: <code>, <code>-2.., <code>-SEK, <code>-SEK-2.. (a cart that switched currency drops the
  // other currency's code).
  function isRuleCode(rule, c) {
    var k = rule.family.toUpperCase();
    c = String(c).toUpperCase();
    return c === k || c.indexOf(k + '-') === 0;
  }

  // Re-render the drawer. Dawn's renderContents also opens it, so a closed drawer is only re-rendered.
  async function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
    try {
      var res = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: H });
      var sections = await res.json();
      if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: sections });
        return;
      }
      drawer.getSectionsToRender().forEach(function (section) {
        var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (target && sections[section.id]) target.innerHTML = drawer.getSectionInnerHTML(sections[section.id], section.selector);
      });
    } catch (e) { console.warn('[LH Cross-sell cart] drawer refresh failed', e); }
  }

  async function enforce() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: H })).json();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var next = codes.slice(), changed = false;
      // One second item per main item, quantity 1 (Leon, 24.10.2026). Quantity 2 on a second pair made Shopify split
      // the line by discount allocation: two pair lines at full price, the discount jumped to the main pair. The cart
      // hides the quantity picker on these lines; this catches everything else (old drawer, other scripts).
      var updates = {}, seenParent = {};
      (cart.items || []).forEach(function (i) {
        if (!rules.some(function (r) { return isPair(r, i, cart.items); })) return;
        var parent = String(i.properties._parent_customization_id);
        var want = seenParent[parent] ? 0 : 1;
        seenParent[parent] = true;
        if (i.quantity !== want) { updates[i.key] = want; changed = true; }
      });
      rules.forEach(function (r) {
        var n = pairsInCart(r, cart.items || []);
        if (!n && pending[r.code.toUpperCase()]) n = 1;
        var want = codeFor(r, n);
        var mine = codes.filter(function (c) { return isRuleCode(r, c); });
        if (mine.length === 1 && String(mine[0]).toUpperCase() === want.toUpperCase()) return;
        if (!mine.length && !want) return;
        next = next.filter(function (c) { return !isRuleCode(r, c); });
        if (want) next.push(want);
        changed = true;
      });
      if (changed) {
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-LH-Cart': '1' },
          body: JSON.stringify({ updates: updates, discount: next.join(',') })
        });
        if (res.ok) await refresh();
      }
    } catch (e) {
      console.warn('[LH Cross-sell cart] check failed', e);
    } finally {
      busy = false;
      if (again) { again = false; setTimeout(enforce, 150); }
    }
  }

  window.lhCrossSellPending = function (code, on) {
    var key = String(code || '').trim().toUpperCase();
    if (!key) return;
    if (on) pending[key] = true;
    else delete pending[key];
    enforce();
  };

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var own = (typeof h.get === 'function' ? h.get('X-LH-Cart') : h['X-LH-Cart']) === '1';
    var p = origFetch.apply(this, arguments);
    if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) setTimeout(enforce, 350); }).catch(function () {});
    }
    return p;
  };

  window.lhCrossSellEnforce = enforce;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
})();
